import store from '@/store/index.js'
const router_domain_url = store.state.router_domain_url

// 异步请求处理
/**
 *
 * @param {路径} path
 * @param {组件路径} file
 * @param {别名，没有传null } name
 * @param {说明，没有就传{} } meta
 * @param {子级，没有子级可以不传} children
 */
function route(path, file, name, meta, children, redirect) {
  return {
    exact: true,
    path,
    name,
    meta,
    children,
    redirect,
    component: () => import(`@/views/customization/${router_domain_url}/pages/${file}`)
  }
}
const indexRouterlist = [
  route('/order-pack-pay', 'Orders/OrderpackPay', 'OrderpackPay', { title: '订单打包', ssr: true, pageWidth: true, keepAlive: true, requireAuth: false }),
  route('/advance-order', 'home/advanceorder', 'advance-order', { title: '预报下单', ssr: true,  pageWidth: true, keepAlive: true, requireAuth: false }),
]
const publicRouterlist = [
    route('/sign-up', 'public/SignUp', 'signUp', { title: '注册', ssr: true,  pageWidth: true, keepAlive: false, requireAuth: false }),
    route('/sign-in', 'public/SignIn', 'signIn', { title: '登录', ssr: true,  pageWidth: true, keepAlive: false, requireAuth: false }),
]
const personRouterlist = [
  route('/add-address', 'address/AddAddress', '', { title: '添加地址', ssr: true, pageWidth: true, keepAlive: false, requireAuth: true }),
  route('/order-pack', 'Orders/Orderpack', '', { title: '订单待打包', ssr: true,  pageWidth: true, keepAlive: false, requireAuth: true }),
  route('/edit-user', 'profile/editUser', '', { title: '修改个人资料', ssr: true,  pageWidth: true, keepAlive: false, requireAuth: true }),
  route('/parcel-Claim', 'Orders/parcelClaim', 'parcelClaim', { title: '包裹认领', ssr: true,  pageWidth: true, keepAlive: false, requireAuth: true }),
]

export default {
  publicRouterlist: publicRouterlist,
  indexRouterlist: indexRouterlist,
  personRouterlist: personRouterlist,
}
